// @flow
import React from 'react';
import DeployModal from '~/pages/components/PageList/DeployModal';
import useDeploymentHistory from '~/deploy/components/useDeploymentHistory';
import useScheduledDeployment from '~/deploy/components/useScheduledDeployment';
import getNextVersion from '~/lib/getNextVersion';

type Props = {
  pages: Array<{ title: string, path: string, pageVersionId: string }>,
  onDone: () => void,
  onCancel: () => void
};

/**
 * Redeploys a list of live pages with the existing "Redeploy selected" flow,
 * using each page's published version id. Mounted only when needed, so the
 * deployment queries don't run on every widget builder load.
 */
const RedeployModal = ({ pages, onDone, onCancel }: Props) => {
  const { activeDeployment, deploymentHistory } = useDeploymentHistory({ onlyVersions: true });
  const { scheduledDeployment } = useScheduledDeployment();
  const nextVersion = getNextVersion(activeDeployment, scheduledDeployment, deploymentHistory);

  return (
    <DeployModal
      pages={pages}
      selectedVersionIds={pages.map(p => p.pageVersionId)}
      nextVersion={nextVersion}
      onDeploy={onDone}
      onCancel={onCancel}
    />
  );
};

export default RedeployModal;
